/* eslint-disable prefer-template */
import React from 'react';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from '../../../SearchPage/Filters/Filter';
import ButtonFilter from '../../../SearchPage/Filters/FilterComponents/CoreComponents/ButtonFilter';
import { gameTypeValues } from '../../../../utils/eventConstants';

import styles from '../../../SearchPage/search.scss';

const PlayerTypeFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const { SINGLES, DOUBLES } = gameTypeValues;

    const options = [
        { label: `All players`, value: '' },
        { label: `Singles`, value: SINGLES },
        { label: `Doubles`, value: DOUBLES },
    ];

    const filterName = 'playerType';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                handleFilterClick={handleFilterClick}
                isActive={(filters?.playerType) || filterModal === filterName}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                <div className={styles.flexContainer}>
                    <span className={styles.textStyle} data-testid={dataTestId && `${dataTestId}.label`}>
                        {filters?.playerType ? `${filters.playerType}` : 'All players'}
                    </span>
                    <i className={`uts uts-expand ${styles.iconStyle}`} />
                </div>
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Player Type'}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <ButtonFilter
                            options={options}
                            selected={filterInputs.playerType}
                            data-testid={dataTestId && `${dataTestId}.options`}
                            onClick={(playerType) => {
                                handleFilterUpdate({
                                    playerType,
                                    ...(playerType === SINGLES ? { gender: '' } : {}),
                                    selectedDivs: [],
                                    selectedDraws: [],
                                    selectedDates: [],
                                }, 'submit');
                            }}
                        />

                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

PlayerTypeFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};
PlayerTypeFilter.defaultProps = {
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};

export default PlayerTypeFilter;
